import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import AnalyticsIndex from './analyticsIndex';
import AnalyticsEdit from './analyticsEdit';
import AnalyticsExplore from './analyticsExplore';
import AnalyticsExploreAxisSettings from './analyticsExploreAxisSettings';

export default angular.module('app.components.analytics', [
  'ui.router',
  AnalyticsIndex.name,
  AnalyticsEdit.name,
  AnalyticsExplore.name,
  AnalyticsExploreAxisSettings.name
])
  .config(($stateProvider) => {
    $stateProvider
      .state('app.analytics', {
        abstract: true,
        url: '/analytics/:gameId',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous', 'SELLER_ONLY'],
            redirectTo: 'login'
          }
        },
        params: { preFetchedGame: null }
      })
      .state('app.analytics.index', {
        url: '',
        template: '<analytics-index></analytics-index>',
        data: {
          permissions: {
            except: ['BUYER_ONLY'],
            redirectTo: 'login'
          }
        },
        resolve: {
          $title: ($filter, $stateParams, GamesResource, currentGame) => {
            if($stateParams.preFetchedGame && $stateParams.preFetchedGame.id === parseInt($stateParams.gameId)) {
              $filter('translate')('$state.app.analytics.index', {name: $stateParams.preFetchedGame.name});
            } else {
              return GamesResource.one($stateParams.gameId).get()
                .then(game => {
                  $filter('translate')('$state.app.analytics.index', {name: game.name});
                  currentGame.onNext(game);
                });
            }
          }
        }
      })
      .state('app.analytics.edit', {
        url: '/settings',
        template: '<analytics-edit></analytics-edit>',
        resolve: {
          $title: ($filter, $stateParams, GamesResource, currentGame) => {
            if($stateParams.preFetchedGame && $stateParams.preFetchedGame.id === parseInt($stateParams.gameId)) {
              $filter('translate')('$state.app.analytics.edit', {name: $stateParams.preFetchedGame.name});
            } else {
              return GamesResource.one($stateParams.gameId).get()
                .then(game => {
                  $filter('translate')('$state.app.analytics.edit', {name: game.name});
                  currentGame.onNext(game);
                });
            }
          }
        }
      })
      .state('app.analytics.explore', {
        url: '/explore/:axisName',
        template: '<analytics-explore></analytics-explore>',
        data: {
          permissions: {
            except: ['BUYER_ONLY'],
            redirectTo: 'login'
          }
        },
        resolve: {
          $title: ($filter, $stateParams, GamesResource, currentGame) => {
            if($stateParams.preFetchedGame && $stateParams.preFetchedGame.id === parseInt($stateParams.gameId)) {
              $filter('translate')('$state.app.analytics.explore', {name: $stateParams.preFetchedGame.name});
            } else {
              return GamesResource.one($stateParams.gameId).get()
                .then(game => {
                  $filter('translate')('$state.app.analytics.explore', {name: game.name});
                  currentGame.onNext(game);
                });
            }
          }
        }
      })
  });


/** WEBPACK FOOTER **
 ** ./src/components/analytics/analytics.js
 **/